import React from "react";
import { Button } from "@material-ui/core";
import LaunchIcon from "@material-ui/icons/Launch";
import { makeStyles } from "@material-ui/core/styles";
import { useRecordContext } from "react-admin";
import { colors } from "lib/constants/colors";
import { User } from "types/graphql";

const useStyles = makeStyles({
  button: {
    backgroundColor: colors.skyColor[5],
    color: "#FFFFFF",
    "&:hover": {
      backgroundColor: colors.skyColor[6],
    },
    "&:disabled": {
      backgroundColor: colors.gray[3],
      color: "#FFFFFF",
      opacity: 0.7,
      cursor: "not-allowed",
    },
  },
});

export const ViewInRevenueCatButton: React.FC = () => {
  const classes = useStyles();
  const record = useRecordContext<User>();

  if (record?.primarySubscription?.provider?.name !== "revenuecat") {
    return null;
  }

  const revenueCatUrl = `https://app.revenuecat.com/customers/${process.env.REACT_APP_REVENUECAT_PROJECT_ID}/${record.uid}`;

  return (
    <Button
      href={revenueCatUrl}
      target="_blank"
      rel="noopener noreferrer"
      startIcon={<LaunchIcon />}
      size="small"
      className={classes.button}
    >
      View in RevenueCat
    </Button>
  );
};
